import React, { useEffect, useState } from "react";

import { set, useForm } from "react-hook-form";

import { ICTABanner } from "../../models/ctaBanner/CTABanner";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import Flyout, { FlyoutControlProps } from "../../containers/Flyout";
import { StyledTextInput } from "../Shared/StyledInputs/StyledTextInput";
import { useCTABannerMutations } from "../../data/ctaBanners/useCTABannerMutations";
import { PhotographIcon } from "@heroicons/react/outline";
import InsertMediaModal from "../MediaManager/InsertMediaModal";
import { apiUrl } from "../../services/config";

function MediaPreview({ mediaId }: { mediaId: string }) {
  return (
    <img
      src={`${apiUrl}/api/media/${mediaId}`}
      alt="Media Preview"
      className="w-full h-32 object-contain rounded-md"
    />
  );
}

interface CreateUpdateCTABannerFlyoutProps extends FlyoutControlProps {
  agencyId: string;
  ctaBanner?: ICTABanner;
}

export function CreateUpdateCTABannerFlyout({ open, setOpen, agencyId, ctaBanner }: CreateUpdateCTABannerFlyoutProps) {
  const [mediaOpen, setMediaOpen] = useState(false);
  const { create, update } = useCTABannerMutations(agencyId)
  const isUpdate = ctaBanner !== undefined;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<ICTABanner>({
    defaultValues: { name: "" }
  });

  const handleMediaInsert = (_: never, __: never, selectedMedia: any) => {
    setValue("mediaId", selectedMedia.id);
    setMediaOpen(false);
  }

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      reset({ name: "", mediaId: "", link: "" });
    }, 620);
  }

  const onSubmit = (data: ICTABanner) => {
    if (isUpdate) {
      update.mutate(data, { onSuccess: handleClose });
    } else {
      create.mutate(data, { onSuccess: handleClose });
    }
  }

  useEffect(() => {
    if (ctaBanner) {
      reset(ctaBanner);
    } else {
      reset({ name: "", mediaId: "", link: "" });
    }
  }, [ctaBanner, reset]);

  return (
    <>
      <InsertMediaModal
        isAdmin={false}
        allowVideo={false}
        allowURL={false}
        open={mediaOpen}
        setOpen={setMediaOpen}
        title="Choose Media"
        confirmButtonText="Insert"
        onInsert={handleMediaInsert}
      />
      <Flyout
        disableClickAway
        open={open}
        setOpen={setOpen}
        title={isUpdate ? "Update CTA Banner" : "Create CTA Banner"}
      >
        <div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <StyledTextInput
              label="Name"
              register={register}
              registerName="name"
              registerOptions={{ required: "Name is required" }}
            />
            <div>
              <p className="mb-1 text-sm">Media</p>
              {watch("mediaId") ?
                <MediaPreview mediaId={watch("mediaId")} /> :
                (
                  <ButtonInput
                    isSubmit={false}
                    onClick={() => setMediaOpen(true)}
                    label="Select Media"
                    classes="!w-full"
                  />
                )}
            </div>
            <StyledTextInput
              label="Link URL"
              register={register}
              registerName="link"
              registerOptions={{ required: "Link URL is required" }}
            />
            <div className="mt-6 sm:col-span-2">
              <ButtonInput
                isSubmit={true}
                label={isUpdate ? "Update CTA Banner" : "Create CTA Banner"}
                onClick={undefined}
                children={undefined}
                classes={undefined}
              />
            </div>
          </form>
        </div>
      </Flyout>
    </>
  )
}